export const getPanLimits = (bounds) => {
    const min = {
        x: bounds.min.x - 1,
        y: bounds.min.y - 1,
        z: bounds.min.z - 1
    };
    const max = {
        x: bounds.max.x + 1,
        y: bounds.max.y + 1,
        z: bounds.max.z + 1
    };
    return { max, min };
};
/**
 * Check if a object is facing the camera
 * @param coreApi CoreApi
 * @param objectDirection Object direction using euler degrees.
 * @returns true if object is facing camera
 */
export function isFacingCamera(coreApi, objectDirection) {
    // Normalize directions to be within [0, 360) range
    const cameraDirection = normalizeDirection(coreApi.camera.getCameraTransform().rotation.toEulerDegrees().Y);
    objectDirection = normalizeDirection(objectDirection);
    // Calculate the absolute difference between the two directions
    let degreeDifference = Math.abs(cameraDirection - objectDirection);
    // If the difference is greater than 180 degrees, take the complement
    if (degreeDifference > 180) {
        degreeDifference = 360 - degreeDifference;
    }
    return !(degreeDifference > 90 && degreeDifference < 270);
}
export function normalizeDirection(direction) {
    // Normalize direction to be within [0, 360) range
    direction %= 360;
    if (direction < 0) {
        direction += 360;
    }
    return direction;
}
export const eulerDegreesToRadians = (degrees) => {
    return degrees * (Math.PI / 180);
};
export const raycastCameraTarget = (ipexViewer) => {
    if (!ipexViewer || Object.keys(ipexViewer).length === 0)
        return null;
    const forwardDirection = ipexViewer.get_active_camera()?.forward;
    const cameraPosition = ipexViewer.get_active_camera()?.position;
    if (!forwardDirection || !cameraPosition)
        return;
    return ipexViewer.raycast_object_using_ray(cameraPosition, {
        x: forwardDirection.x,
        y: forwardDirection.y,
        z: forwardDirection.z
    });
};
//# sourceMappingURL=camera.js.map